import React from 'react';

import { Typography, Box, useTheme } from '@mui/material';
import { tokens } from 'theme';
import styles from './styles.module.sass';

type Props = {
  title: string;
  subtitle?: string;
};

export const ScreenTitle: React.FC<Props> = ({ title, subtitle }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box mb='30px'>
      <Typography variant='h2' color={colors.heading.main} fontWeight='bold' className={styles.main}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant='h5' color={colors.greenAccent[400]}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};
